// getNameVerificationCriteria from espy-dashboard src/function/string.ts.
export function getNameVerificationCriteria(nameVerificationCriteria: any, counter: number) {
  // row.criteria for lookup_phone_name_verification is normally a JSON string
  // like {"phoneNumber":"...","name":"..."}, but this crashed the whole page
  // (uncaught SyntaxError from JSON.parse, with no error boundary around the
  // results table) whenever a result came back with criteria that wasn't
  // valid JSON — null, a plain string, or already-parsed. Same defensive
  // try/catch-with-fallback already used a few lines down in
  // RenderTableBody.tsx for public_company_info/profilerName.
  const raw = String(nameVerificationCriteria ?? '')
  let criteria: any
  try {
    criteria = JSON.parse(raw)
  } catch {
    criteria = null
  }
  let resultString: string = raw.substr(0, counter) + "..."
  if (criteria?.phoneNumber && criteria?.name) {
    resultString = `${criteria.phoneNumber}/${criteria.name}`
    if (resultString.length > counter) {
      return resultString.substr(0, counter) + "..."
    }
  }
  return resultString
}
